import React, { useEffect, useState } from "react";
import { connectToStore } from "../data/store";
import UserHelper from "../core/UserHelper";
import { useLocation, useNavigate } from "react-router-dom";
import {
  LoginPage,
  OverviewPage,
  ProductIntakesPage,
  ProductInvoicePage,
} from "../core/PageConstants";
import { Box, Container, Stack } from "@mui/system";
import {
  Button,
  Card,
  Divider,
  Grid,
  Tab,
  Tabs,
  Tooltip,
  Typography,
} from "@mui/material";
import MessagePopup from "./common/MessagePopUp";
import SideBarMenuItems from "./SideBarMenuItems";
import { MaxDateLimit, SideBarMenuNames } from "../core/Constants";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import Loader from "./common/Loader";
import { postAsync } from "../core/serviceClient";
import Utils from "../core/Utils";
import { useDispatch } from "react-redux";
import { getCountry } from "../data/localSettingsActions";
import dayjs from "dayjs";
import CountryHelper from "../core/CountryHelper";
import DateRangePicker from "@wojtekmaj/react-daterange-picker";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import moment from "moment";
import PropTypes from "prop-types";
import FileDownloadIcon from '@mui/icons-material/FileDownload';

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const ProductIntakes = () => {
  document.title = "Product Intakes";
  var pageTitle = "Product Intakes";
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const [localSettings, setLocalSettings] = useState({});
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [productIntakesList, setProductIntakesList] = useState([]);
  const [productIntakesSavedList, setProductIntakesSavedList] = useState([]);
  const [productIntakesUpdatedList, setProductIntakesUpdatedList] = useState(
    []
  );
  const [isNavigateToLogin, setIsNavigateToLogin] = useState(false);
  const [countryInfo, setCountryInfo] = useState({});
  const [selectedDate, setSelectedDate] = useState([
    Utils.GetStartDate(),
    Utils.GetEndDate(),
  ]);
  const [value, setValue] = React.useState(0);
  const [savedProductIntakes, setSavedProductIntakes] = useState([]);
  const [updatedProductIntakes, setUpdatedProductIntakes] = useState([]);

  useEffect(() => {
    let localSetting = connectToStore();
    if (UserHelper.CheckPermission(ProductIntakesPage, navigate)) {
      setLocalSettings(localSetting);
      var country = getCountry();
      setCountryInfo(country);
    }
  }, []);

  useEffect(() => {
    getProductIntakes(selectedDate[0], selectedDate[1]);
  }, [localSettings]);

  const getProductIntakes = async (startDT, endDT) => {
    if (localSettings.authenticated) {
      setIsLoading(true);
      let localSetting = connectToStore();
      let result = await postAsync("ProductIntakes/GetAllProductIntakes", {
        Start: Utils.GetISODateTimeString(startDT),
        End: Utils.GetISODateTimeString(endDT),
        BusinessId: localSetting.business.businessId,
        BranchId: localSetting.branch.branchId,
      });
      setIsNavigateToLogin(result.isNavigateToLogin);
      if (result.error) {
        setAlert(result.error);
      }
      else {
        if (!Utils.IsNullOrEmptyArray(result.data)) {
          setProductIntakesList(result.data);
          let savedData = result.data.filter((item) => item.status === "Saved").reverse();
          let updatedData = result.data.filter(
            (item) => item.status === "Updated"
          ).reverse();
          setProductIntakesSavedList(savedData);
          setProductIntakesUpdatedList(updatedData);
        }
      }
      setIsLoading(false);
    }
  };

  const setAlert = (msg) => {
    setAlertMessage(msg);
    setShowAlert(true);
  };

  const handleMsgClose = () => {
    setShowAlert(false);
    if (isNavigateToLogin) {
      UserHelper.LogOut(dispatch);
      navigate(LoginPage.Path);
    }
  };

  const backNavigation = () => {
    navigate(OverviewPage.Path);
  };

  const handleNavigateToAddProducts = () => {
    navigate(ProductInvoicePage.Path);
  };

  const onDateChange = (date) => {
    if (!Utils.IsNullOrEmptyArray(date)) {
      var dateArray = [moment(date[0]), moment(date[1])];
      if (dateArray[0]._isValid == false || dateArray[1]._isValid == false) {
        setAlert("Please select a valid date range.");
      } else {
        let dateDiff = dateArray[1].diff(dateArray[0], "days");
        if (dateDiff > MaxDateLimit) {
          setAlert(
            "Please note that the maximum date range you can select is 90 days. You can choose any start date within the past 90 days, but the end date cannot exceed this limit."
          );
        } else {
          setSelectedDate(dateArray);
          getProductIntakes(dateArray[0], dateArray[1]);
        }
      }
    }
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleUpdateProductIntake = (productIntake) => {
    if (!Utils.IsNullOrEmptyObject(productIntake)) {
      let obj = {
        isProductIntakeEdit: true,
        storedProductIntake: productIntake,
      };
      location.state = obj;
      navigate(ProductInvoicePage.Path, {
        state: obj,
      });
    }
  };

  return (
    <Container maxWidth="false" className="bg-color p-0">
      <Grid className="container">
        <Loader open={isLoading} />
        <MessagePopup
          msgOpen={showAlert}
          msgText={alertMessage}
          onMsgClose={handleMsgClose}
        />
        <Box>
          <Grid container m={0}>
            <SideBarMenuItems selectedTab={SideBarMenuNames.Overview} />
            <Grid
              xs={12}
              className="content-sec"
              sx={{ "padding-bottom": "100px" }}
            >
              <Grid container direction="row" className="">
                <Grid container className="title-sec">
                  <Grid xs={12}>
                    <Box
                      display="flex"
                      alignItems="center"
                      justifyContent="space-between"
                    >
                      <Typography
                        level="h2"
                        component="h2"
                        fontWeight="600"
                        fontSize="2rem"
                      >
                        <Button onClick={backNavigation} className="back-btn">
                          <NavigateBeforeIcon />
                        </Button>
                        {pageTitle} - {productIntakesList.length}
                      </Typography>
                      <Stack direction="row" spacing={2}>
                        <DateRangePicker
                          showLeadingZeros={true}
                          onChange={onDateChange}
                          maxDate={new Date()}
                          value={selectedDate}
                          locale={CountryHelper.GetDateCulture(
                            countryInfo.Culture
                          )}
                          clearIcon={null}
                          calendarIcon={
                            <CalendarMonthOutlinedIcon
                              style={{
                                "font-size": "24px",
                                "align-self": "center",
                                color: "#666666",
                              }}
                            />
                          }
                        />
                        <Button
                          className="btn btn-primary float-btn"
                          variant="contained"
                          onClick={() => {
                            handleNavigateToAddProducts();
                          }}
                        >
                          Add Product Intakes
                        </Button>
                      </Stack>
                    </Box>
                  </Grid>
                  <Box className="w-100">
                    <Box
                      sx={{ borderBottom: 1, borderColor: "divider" }}
                      className="font-size-14"
                    >
                      <Tabs
                        value={value}
                        onChange={handleChange}
                        aria-label="basic tabs example"
                      >
                        <Tab
                          label={"Saved - " + productIntakesSavedList.length}
                          {...a11yProps(0)}
                        />
                        <Tab
                          label={
                            "Updated - " + productIntakesUpdatedList.length
                          }
                          {...a11yProps(1)}
                        />
                      </Tabs>
                    </Box>
                    <CustomTabPanel value={value} index={0}>
                      {!Utils.IsNullOrEmptyArray(productIntakesSavedList) &&
                        productIntakesSavedList.map((productlist) => (
                          <Grid
                            container
                            xs={12}
                            className="card white-bg mt-2"
                          >
                            <Grid container xs={12}>
                              <Grid
                                sx={{ cursor: "pointer" }}
                                onClick={(e) =>
                                  handleUpdateProductIntake(productlist)
                                }
                                xs={12}
                              >
                                <Stack direction="row" spacing={2} padding={2}>
                                  <Grid container xs={12}>
                                    <Grid xs={9}>
                                      <Typography
                                        level="p"
                                        component="p"
                                        fontSize="1.5rem"
                                      >
                                        <Typography
                                          level="strong"
                                          component="strong"
                                          fontSize="1.5rem"
                                          fontWeight="600"
                                        >
                                          Vendor Name : &nbsp;
                                        </Typography>
                                        {productlist.vendorName}
                                      </Typography>
                                    </Grid>
                                    <Grid xs={3}>
                                      <Typography
                                        level="p"
                                        component="p"
                                        fontSize="1.5rem"
                                      >
                                        <Typography
                                          level="strong"
                                          component="strong"
                                          fontSize="1.5rem"
                                          fontWeight="600"
                                        >
                                          Invoice Number : &nbsp;
                                        </Typography>
                                        {productlist.invoiceNumber}
                                      </Typography>
                                      <Typography
                                        level="p"
                                        component="p"
                                        fontSize="1.5rem"
                                      >
                                        <Typography
                                          level="strong"
                                          component="strong"
                                          fontSize="1.5rem"
                                          fontWeight="600"
                                        >
                                          Invoice Date : &nbsp;
                                        </Typography>
                                        {dayjs(productlist.invoiceDate).format(
                                          "DD MMM YYYY, hh:mm a"
                                        )}
                                      </Typography>
                                    </Grid>
                                  </Grid>
                                </Stack>
                                <Stack direction="row" spacing={2} >
                                  <Grid container xs={12}>
                                    {!Utils.IsNullOrEmpty(productlist.invoiceCopyUrl) && <Typography
                                      level="p"
                                      component="p"
                                      fontSize="1.5rem"
                                    >
                                      <Typography
                                        level="strong"
                                        component="strong"
                                        fontSize="1.5rem"
                                        fontWeight="600"
                                      >
                                        Invoice Copy : &nbsp;
                                        <Tooltip title="Download Invoice" arrow>
                                          <FileDownloadIcon
                                            onClick={(e) => { e.stopPropagation(); window.open(productlist.invoiceCopyUrl) }}
                                            className="custom-download-icon"
                                            style={{ cursor: "pointer", fontSize: 24 }}
                                          />
                                        </Tooltip>
                                      </Typography>
                                    </Typography>}
                                  </Grid>
                                </Stack>
                                <Grid container xs={12} paddingLeft={2} paddingRight={2} className="mb-1">
                                  <Grid xs={12} sx={{ background: "#f4f4f4", borderRadius: "6px" }}>
                                    <Grid
                                      container
                                      xs={12}
                                      spacing={1}
                                      padding="15px 20px 5px 20px"
                                      direction="row"
                                    >
                                      <Grid xs={6}>
                                        <Typography
                                          level="h4"
                                          component="h4"
                                          fontWeight="700"
                                          fontSize="1.3rem"
                                        >
                                          Products
                                        </Typography>
                                      </Grid>
                                      <Grid xs={2}>
                                        {!Utils.IsNullOrEmptyArray(
                                          productlist.serviceItems
                                        ) &&
                                          productlist.serviceItems.some(
                                            (x) => x?.discountTotal > 0
                                          ) && (
                                            <Typography
                                              level="h4"
                                              component="h4"
                                              fontWeight="700"
                                              fontSize="1.3rem"
                                              className="text-right"
                                            >
                                              Discount Total
                                            </Typography>
                                          )}
                                      </Grid>
                                      <Grid xs={2}>
                                        <Typography
                                          level="h4"
                                          component="h4"
                                          fontWeight="700"
                                          fontSize="1.3rem"
                                          className="text-right"
                                        >
                                          Unit Price
                                        </Typography>
                                      </Grid>
                                      <Grid xs={2}>
                                        <Typography
                                          level="h4"
                                          component="h4"
                                          fontWeight="700"
                                          fontSize="1.3rem"
                                          className="text-right"
                                        >
                                          Total Price
                                        </Typography>
                                      </Grid>
                                    </Grid>
                                    <Divider />
                                    {!Utils.IsNullOrEmptyArray(
                                      productlist?.serviceItems
                                    ) &&
                                      productlist.serviceItems.map((item) => (
                                        <Grid xs={12}>
                                          <Grid
                                            container
                                            xs={12}
                                            spacing={1}
                                            padding={2}
                                            direction="row"
                                          >
                                            <Grid xs={6}>
                                              <Typography
                                                level="p"
                                                component="p"
                                                fontSize="1.5rem"
                                                fontWeight="500"
                                              >
                                                {item.description}
                                              </Typography>
                                            </Grid>
                                            <Grid xs={2}>
                                              {item.discountTotal > 0 && (
                                                <Typography
                                                  level="p"
                                                  component="p"
                                                  fontSize="1.5rem"
                                                  fontWeight="500"
                                                  className="text-right"
                                                >
                                                  {item.discountTotal}
                                                </Typography>
                                              )}
                                            </Grid>
                                            <Grid xs={2}>
                                              <Typography
                                                level="p"
                                                component="p"
                                                fontSize="1.5rem"
                                                fontWeight="500"
                                                className="text-right"
                                              >
                                                {item.quantity +
                                                  " x " +
                                                  Utils.GetCurrency(
                                                    item.price,
                                                    countryInfo
                                                  )}
                                              </Typography>
                                            </Grid>
                                            <Grid xs={2}>
                                              <Typography
                                                level="p"
                                                component="p"
                                                fontSize="1.5rem"
                                                fontWeight="500"
                                                className="text-right"
                                              >
                                                {Utils.GetCurrency(
                                                  item.totalPriceIncludingTax,
                                                  countryInfo
                                                )}
                                              </Typography>
                                            </Grid>
                                          </Grid>
                                        </Grid>
                                      ))}
                                  </Grid>
                                </Grid>
                              </Grid>
                            </Grid>
                          </Grid>
                        ))}
                    </CustomTabPanel>
                    <CustomTabPanel value={value} index={1}>
                      {!Utils.IsNullOrEmptyArray(productIntakesUpdatedList) &&
                        productIntakesUpdatedList.map((productlist) => (
                          <Grid
                            container
                            xs={12}
                            className="card white-bg mt-2"
                          >
                            <Grid container xs={12}>
                              <Grid xs={12}>
                                <Stack direction="row" spacing={2} padding={2}>
                                  <Grid container xs={12}>
                                    <Grid xs={9}>
                                      <Typography
                                        level="p"
                                        component="p"
                                        fontSize="1.5rem"
                                      >
                                        <Typography
                                          level="strong"
                                          component="strong"
                                          fontSize="1.5rem"
                                          fontWeight="600"
                                        >
                                          Vendor Name : &nbsp;
                                        </Typography>
                                        {productlist.vendorName}
                                      </Typography>
                                    </Grid>
                                    <Grid xs={3}>
                                      <Typography
                                        level="p"
                                        component="p"
                                        fontSize="1.5rem"
                                      >
                                        <Typography
                                          level="strong"
                                          component="strong"
                                          fontSize="1.5rem"
                                          fontWeight="600"
                                        >
                                          Invoice Number : &nbsp;
                                        </Typography>
                                        {productlist.invoiceNumber}
                                      </Typography>
                                      <Typography
                                        level="p"
                                        component="p"
                                        fontSize="1.5rem"
                                        className="m-0"
                                      >
                                        <Typography
                                          level="strong"
                                          component="strong"
                                          fontSize="1.5rem"
                                          fontWeight="600"
                                        >
                                          Invoice Date : &nbsp;
                                        </Typography>
                                        {dayjs(productlist.invoiceDate).format(
                                          "DD MMM YYYY, hh:mm a"
                                        )}
                                      </Typography>
                                    </Grid>
                                  </Grid>
                                </Stack>
                                <Stack direction="row" spacing={2} >
                                  {!Utils.IsNullOrEmpty(productlist.invoiceCopyUrl) && <Grid container xs={12}>
                                    <Typography
                                      level="p"
                                      component="p"
                                      fontSize="1.5rem"
                                    >
                                      <Typography
                                        level="strong"
                                        component="strong"
                                        fontSize="1.5rem"
                                        fontWeight="600"
                                      >
                                        Invoice Copy : &nbsp;
                                        <Tooltip title="Download Invoice" arrow>
                                          <FileDownloadIcon
                                            onClick={(e) => { e.stopPropagation(); window.open(productlist.invoiceCopyUrl) }}
                                            className="custom-download-icon"
                                            style={{ cursor: "pointer" }}
                                          />
                                        </Tooltip>
                                      </Typography>
                                    </Typography>
                                  </Grid>}
                                </Stack>
                                <Grid container xs={12} paddingLeft={2} paddingRight={2} className="mb-1">
                                  <Grid xs={12} sx={{ background: "#f4f4f4", borderRadius: "6px" }}>
                                    <Grid
                                      container
                                      xs={12}
                                      spacing={1}
                                      padding="15px 20px 5px 20px"
                                      direction="row"
                                    >
                                      <Grid xs={6}>
                                        <Typography
                                          level="h4"
                                          component="h4"
                                          fontWeight="700"
                                          fontSize="1.3rem"
                                        >
                                          Products
                                        </Typography>
                                      </Grid>
                                      <Grid xs={2}>
                                        {!Utils.IsNullOrEmptyArray(
                                          productlist.serviceItems
                                        ) &&
                                          productlist.serviceItems.some(
                                            (x) => x?.discountTotal > 0
                                          ) && (
                                            <Typography
                                              level="h4"
                                              component="h4"
                                              fontWeight="700"
                                              fontSize="1.3rem"
                                              className="text-right"
                                            >
                                              Discount Total
                                            </Typography>
                                          )}
                                      </Grid>
                                      <Grid xs={2}>
                                        <Typography
                                          level="h4"
                                          component="h4"
                                          fontWeight="700"
                                          fontSize="1.3rem"
                                          className="text-right"
                                        >
                                          Unit Price
                                        </Typography>
                                      </Grid>
                                      <Grid xs={2}>
                                        <Typography
                                          level="h4"
                                          component="h4"
                                          fontWeight="700"
                                          fontSize="1.3rem"
                                          className="text-right"
                                        >
                                          Total Price
                                        </Typography>
                                      </Grid>
                                    </Grid>
                                    <Divider />
                                    {!Utils.IsNullOrEmptyArray(
                                      productlist?.serviceItems
                                    ) &&
                                      productlist.serviceItems.map((item) => (
                                        <Grid xs={12}>
                                          <Grid
                                            container
                                            xs={12}
                                            spacing={1}
                                            padding={2}
                                            direction="row"
                                          >
                                            <Grid xs={6}>
                                              <Typography
                                                level="p"
                                                component="p"
                                                fontSize="1.5rem"
                                                fontWeight="500"
                                              >
                                                {item.description}
                                              </Typography>
                                            </Grid>
                                            <Grid xs={2}>
                                              {item.discountTotal > 0 && (
                                                <Typography
                                                  level="p"
                                                  component="p"
                                                  fontSize="1.5rem"
                                                  fontWeight="500"
                                                  className="text-right"
                                                >
                                                  {item.discountTotal}
                                                </Typography>
                                              )}
                                            </Grid>
                                            <Grid xs={2}>
                                              <Typography
                                                level="p"
                                                component="p"
                                                fontSize="1.5rem"
                                                fontWeight="500"
                                                className="text-right"
                                              >
                                                {item.quantity +
                                                  " x " +
                                                  Utils.GetCurrency(
                                                    item.price,
                                                    countryInfo
                                                  )}
                                              </Typography>
                                            </Grid>
                                            <Grid xs={2}>
                                              <Typography
                                                level="p"
                                                component="p"
                                                fontSize="1.5rem"
                                                fontWeight="500"
                                                className="text-right"
                                              >
                                                {Utils.GetCurrency(
                                                  item.totalPriceIncludingTax,
                                                  countryInfo
                                                )}
                                              </Typography>
                                            </Grid>
                                          </Grid>
                                        </Grid>
                                      ))}
                                  </Grid>
                                </Grid>
                              </Grid>
                            </Grid>
                          </Grid>
                        ))}
                    </CustomTabPanel>
                  </Box>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </Grid>
    </Container>
  );
};

export default ProductIntakes;
